import { Observable } from 'rxjs';
import { HttpClient } from '@ispm-client/modules/core/services/http-client';
import { Injectable } from '@angular/core';
import { BP_MODEL_URL } from '@ispm/shared/bpmn/services/config';
import {BrowserCacheService} from "@ispm/core/services/browser-cache.service";

@Injectable()
export class BpmnXmlService {
  private _browserCacheService: BrowserCacheService;

  constructor(private http: HttpClient, browserCacheService: BrowserCacheService) {
    this._browserCacheService = browserCacheService;
  }

  getBpmnXml = (deploymentId: string, name: string, kb: string, toggleLoader = true): Observable<string>  => {
    return this.http.get(encodeURI(`${BP_MODEL_URL}?id=${deploymentId}&name=${name}&kb=${kb}&cacheId=${this._browserCacheService.getCacheId()}`), null, toggleLoader, {
      Accept: 'application/xml'
    }, { responseType: 'text'});
  }
}
